<script setup lang="ts">
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const r$ = orderStore.validation.r$;

    const fields = orderStore.options.toggleableFields;
</script>
<template>
    <shared-labeled-field v-slot="{ ariaLabelledby }" label="Naam*">
        <VTextField
            v-model="r$.$value.name"
            :aria-labelledby="ariaLabelledby"
            placeholder="Naam"
            :error-messages="r$.$errors.name"
            @focusout="r$.$fields.name.$touch"
        />
    </shared-labeled-field>
    <shared-labeled-field
        v-if="fields.email?.enabled"
        v-slot="{ ariaLabelledby }"
        :label="`Emailadres${fields.email?.required ? '*' : ''}`"
    >
        <VTextField
            v-model="orderStore.currentOrder.toggleableFields.email"
            :aria-labelledby="ariaLabelledby"
            placeholder="Email"
            :error-messages="r$.$errors.toggleableFields.email"
            @focusout="r$.$fields.toggleableFields.email?.$touch"
        />
    </shared-labeled-field>
    <shared-labeled-field
        v-if="fields.telephone?.enabled"
        v-slot="{ ariaLabelledby }"
        :label="`Telefoonnummer${fields.telephone?.required ? '*' : ''}`"
    >
        <VTextField
            v-model="orderStore.currentOrder.toggleableFields.telephone"
            :aria-labelledby="ariaLabelledby"
            placeholder="Telefoonnummer"
            :error-messages="r$.$errors.toggleableFields.telephone"
            @focusout="r$.$fields.toggleableFields.telephone?.$touch"
        />
    </shared-labeled-field>
</template>
